<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    label="Name"
                    v-model="form.name"
                    outlined
                    dense
                    clearable
                    hide-details="auto"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    label="Code"
                    v-model="form.code"
                    outlined
                    clearable
                    dense
                    hide-details="auto"
                >
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "SupplierListSearch",
    data() {
        return {
            form : {
                name: "",
                code: ""
            }
        }
    },
    computed: {
        ...mapGetters({
            params: "purchase/supplier/list/params"
        })
    },
    methods: {
        ...mapActions({
            updateParams: "purchase/supplier/list/updateParams"
        }),
        submit() {
            this.updateParams(this.form)
        }
    },
    mounted() {
        this.form = {...this.form, ...this.params}
    }
}
</script>

<style>

</style>